import React, { forwardRef } from 'react';
import './InputWithIcon.scss';

const InputWithIcon = forwardRef(({ icon, placeholder, value, onChange, multiline, error, helperText, InputProps, select, displayEmpty, renderValue, children, ...props }, ref) => {
  let InputComponent;
  
  if (select) {
    InputComponent = 'select';
  } else if (multiline) {
    InputComponent = 'textarea';
  } else {
    InputComponent = 'input';
  }
  
  // Filter out MUI-specific props that shouldn't be passed to HTML input
  const htmlProps = { ...props };
  delete htmlProps.sx;
  delete htmlProps.variant;
  delete htmlProps.fullWidth;
  delete htmlProps.SelectProps;
  delete htmlProps.renderValue;
  const inputType = htmlProps.type;
  delete htmlProps.type;
  
  return (
    <div className={`input-with-icon-wrapper ${multiline ? 'multiline' : ''} ${select ? 'select' : ''} ${error ? 'error' : ''}`}>
      {icon && (
        <div className="input-icon-container">
          {typeof icon === 'string' ? (
            <img src={icon} alt="" className="input-icon-img" />
          ) : (
            <div className="input-icon-react">{icon}</div>
          )}
        </div>
      )}
      {select ? (
        <select
          className={`plain-input select-input ${icon ? 'with-icon' : ''}`}
          value={value || ''}
          onChange={onChange}
          name={htmlProps.name}
          ref={ref}
          {...htmlProps}
        >
          {displayEmpty && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {children}
        </select>
      ) : (
        <InputComponent
          className={`plain-input ${icon ? 'with-icon' : ''} ${error ? 'error' : ''}`}
          type={multiline ? undefined : (inputType ?? 'text')}
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          ref={ref}
          {...htmlProps}
        />
      )}
    </div>
  );
});

export default InputWithIcon;